import VehicleFurtherFeatures from "./VehicleFurtherFeatures";

export default VehicleFurtherFeatures;
